import { render, staticRenderFns } from "./HStack.vue?vue&type=template&id=4968875a&scoped=true&"
import script from "./HStack.vue?vue&type=script&lang=js&"
export * from "./HStack.vue?vue&type=script&lang=js&"
import style0 from "./HStack.vue?vue&type=style&index=0&id=4968875a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4968875a",
  null
  
)

/* custom blocks */
import block0 from "./HStack.vue?vue&type=custom&index=0&blockType=meta"
if (typeof block0 === 'function') block0(component)
import block1 from "./HStack.vue?vue&type=custom&index=1&blockType=example"
if (typeof block1 === 'function') block1(component)

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('HStack', component.exports)
}
export default component.exports